/**
 * getIsServiceCreated
 *
 * @description
 * Determine if a service is created by checking if the given URL, preview state
 * and ID are valid.
 * @param {SelectedNewsSource} source - The news source object containing URL and ID.
 * @param {string[]} [sourcesIds] - An optional array of source IDs to check against.
 * @returns {boolean} - If true, the service is considered created; otherwise, false.
 *
 */
const getIsServiceCreated = (source, sourcesIds) => 
// If there's a URL and there's an ID or no URL,
// return true (service created); otherwise, return false (service not created)
(Boolean(source.url) && Boolean(sourcesIds?.includes(source.id))) ||
    !source.url;
export default getIsServiceCreated;
